export default {
    'package_version': '2.0.61009.17'
  };
